/**
 * Lead lookup by phone — BUB-135 convert-to-lead guard.
 */

import api from "../../../shared/api.jsx";

/**
 * @param {string} phone
 * @returns {Promise<{ found: boolean, lead: { leadId, referenceNumber, name, phone, status } | null }>}
 */
export const lookupLeadByPhone = async (phone) => {
  const response = await api.get("/leads/lookup-by-phone", {
    params: { phone },
  });
  return response.data ?? response;
};
